var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27966 3.43387C4.42166 3.58402 4.50153 3.78842 4.50153 4.00164C4.50153 4.21486 4.42166 4.41925 4.27966 4.5694L1.27944 7.76808C1.13974 7.91582 0.951174 7.9991 0.754404 7.99999C0.555037 8.00122 0.363415 7.91777 0.221865 7.76808C0.0798702 7.61793 4.15413e-08 7.41354 4.03465e-08 7.20032C3.91517e-08 6.9871 0.0798702 6.7827 0.221865 6.63255L2.68955 4.00164L0.236866 1.37073C0.0466083 1.16788 -0.0276959 0.872232 0.0419433 0.595143C0.111583 0.318055 0.314585 0.101624 0.574482 0.0273779C0.83438 -0.0468679 1.11169 0.0323514 1.30194 0.235194L4.27966 3.43387Z",
    fill: "#6A8991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow-2.8e11daf617fb3d1e926c90fe6a6d7f8a.svg";
export { ForwardRef as ReactComponent };